import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import type { CreativeGrouping, OverviewFilters } from "@nexus/contracts";
import { CreativeAdSpendBreakdown } from "@/features/explore/components/CreativeAdSpendBreakdown";
import { formatExactCurrency } from "@/features/dashboard/lib/format";
import type { TopicDetailContext } from "@/features/overview/lib/topicDetailContext.js";
import type { MyBrandOverviewFilters } from "@/lib/queries/overview.queries";
import { topicDetailCreativeAdsQueryOptions } from "@/lib/queries/overview.queries";

interface OverviewCreativeAdSpendPanelProps {
  tenantId: string;
  hash: string;
  grouping: CreativeGrouping;
  adsCount: number;
  overviewFilters: OverviewFilters;
  globalFilters: MyBrandOverviewFilters;
  context: TopicDetailContext;
  currencySymbol: string;
}

export function OverviewCreativeAdSpendPanel({
  tenantId,
  hash,
  grouping,
  adsCount,
  overviewFilters,
  globalFilters,
  context,
  currencySymbol,
}: OverviewCreativeAdSpendPanelProps) {
  const [expanded, setExpanded] = useState(false);
  const query = useQuery(
    topicDetailCreativeAdsQueryOptions(
      tenantId,
      hash,
      grouping,
      overviewFilters,
      globalFilters,
      context,
      expanded,
    ),
  );

  return (
    <CreativeAdSpendBreakdown
      variant="collapsible"
      adsCount={adsCount}
      expanded={expanded}
      onToggle={() => setExpanded((current) => !current)}
      section={query.data}
      isLoading={expanded && query.isLoading}
      isError={expanded && query.isError}
      onRetry={() => void query.refetch()}
      formatSpend={(spend) => formatExactCurrency(spend, currencySymbol)}
    />
  );
}
